import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
// 入口文件 main.js 或组件 mounted 里
import config from '@/utils/config';

// import locale from 'element-plus/lib/locale/lang/zh-cn'
import zhCn from 'element-plus/es/locale/lang/zh-cn' 
createApp(App).use(store).use(router).use(ElementPlus,{
    locale: zhCn
}).mount('#app')
